/**
 * @Description
 */


export const YearDataColumns = [
  {
    title: '项目',
    width: 216,
    pdfWidth: 216,
    dataIndex: 'name',
    key: 'name',
    isInput: false,
  },
  {
    title: '第一年',
    width: 353,
    pdfWidth: 163,
    dataIndex: 'firstYear',
    key: 'firstYear',
    isInput: true,
  },
  {
    title: '第二年',
    width: 353,
    pdfWidth: 150,
    dataIndex: 'secondYear',
    key: 'secondYear',
    isInput: true,
  },
];

export const SpecialDataColumns = [
  {
    title: '项目1',
    width: 210,
    pdfWidth: 148,
    dataIndex: 'name1',
    key: 'name1',
    isInput: false,
  },
  {
    title: '值1',
    width: 250,
    pdfWidth: 118,
    dataIndex: 'value1',
    key: 'value1',
    isInput: true,
  },
  {
    title: '项目2',
    width: 210,
    pdfWidth: 148,
    dataIndex: 'name2',
    key: 'name2',
    isInput: false,
  },
  {
    title: '值2',
    width: 250,
    pdfWidth: 118,
    dataIndex: 'value2',
    key: 'value2',
    isInput: true,
  },
];

export interface ModuleConfig {
  title: string;
  key: string;
  isYearData: boolean; // 数据是否区分年维度第一年、第二年
  data: any[];
  columns: any[];
}

export const JNPIdentification = 'profitCalculationJNP';

export enum JNPFormNames {
  // 模块
  saleTarget = 'saleTarget',
  operatingIncome = 'operatingIncome',
  costExpense = 'costExpense',
  employeeCompensationCost = 'employeeCompensationCost',
  storeImageCost = 'storeImageCost',
  storeEngineeringCost = 'storeEngineeringCost',
  leaseCost = 'leaseCost',
  otherCost = 'otherCost',
  // 核心信息
  coreInfoModule = 'coreInfoModule',
  // 年份
  firstYear = 'firstYear',
  secondYear = 'secondYear',
};

export enum SaleTargetNames {
  saleTarget = 'saleTarget',
  saleAmount = 'saleAmount',
  oldProductAmount = 'oldProductAmount',
  newProductAmount = 'newProductAmount',
  oldProductProportion = 'oldProductProportion',
  newProductProportion = 'newProductProportion',
  oldProductDiscount = 'oldProductDiscount',
  newProductDiscount = 'newProductDiscount',
  oldProductPurchaseDiscount = 'oldProductPurchaseDiscount',
  newProductPurchaseDiscount = 'newProductPurchaseDiscount',
}

export const SaleTargetConfig: ModuleConfig = {
  title: '销售目标', // 二级分组标题
  key: JNPFormNames.saleTarget,
  isYearData: true,
  data: [
    {
      key: SaleTargetNames.saleTarget,
      name: '终端销售指标(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: SaleTargetNames.saleAmount,
      name: '吊牌销售总金额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: SaleTargetNames.oldProductAmount,
      name: '老品销售吊牌销售金额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: SaleTargetNames.newProductAmount,
      name: '新品销售吊牌销售金额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: SaleTargetNames.oldProductProportion,
      name: '老品销售额占比',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: SaleTargetNames.newProductProportion,
      name: '新品销售额占比',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      required: true,
    },
    {
      key: SaleTargetNames.oldProductDiscount,
      name: '老品销售折扣',
      firstYear: '',
      secondYear: '',
      min: 0.1,
      unit: '%',
      unitDetail: '%',
      required: true,
    },
    {
      key: SaleTargetNames.newProductDiscount,
      name: '新品销售折扣',
      firstYear: '',
      secondYear: '',
      min: 0.1,
      unit: '%',
      unitDetail: '%',
      required: true,
    },
    {
      key: SaleTargetNames.oldProductPurchaseDiscount,
      name: '老品进货折率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      required: true,
      defaultValue: 35,
    },
    {
      key: SaleTargetNames.newProductPurchaseDiscount,
      name: '新品进货折率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      required: true,
      defaultValue: 35,
    },
  ],
  columns: YearDataColumns
};

export enum OperatingIncomeNames {
  operatingIncome = 'operatingIncome',
  costOfGoods = 'costOfGoods',
  financialGrossProfit = 'financialGrossProfit',
  financialGrossProfitMargin = 'financialGrossProfitMargin',
}

export const OperatingIncomeConfig: ModuleConfig = {
  title: '营业收入', // 二级分组标题
  key: JNPFormNames.operatingIncome,
  isYearData: true,
  data: [
    {
      key: OperatingIncomeNames.operatingIncome,
      name: '营业收入(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: OperatingIncomeNames.costOfGoods,
      name: '商品成本(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: OperatingIncomeNames.financialGrossProfit,
      name: '财务毛利额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: OperatingIncomeNames.financialGrossProfitMargin,
      name: '财务毛利率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
  ],
  columns: YearDataColumns,
};

export enum CostExpenseNames {
  totalFees = 'totalFees',
  totalProfit = 'totalProfit',
  profitMargin = 'profitMargin',
}
export const CostExpenseConfig: ModuleConfig = {
  title: '费用成本', // 二级分组标题
  key: JNPFormNames.costExpense,
  isYearData: true,
  data: [
    {
      key: CostExpenseNames.totalFees,
      name: '费用总额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: CostExpenseNames.totalProfit,
      name: '利润总额(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: CostExpenseNames.profitMargin,
      name: '利润率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
  ],
  columns: YearDataColumns,
};

export enum EmployeeCompensationCostNames {
  employeeSalary = 'employeeSalary',
  monthlySalaryOfShoppingGuide = 'monthlySalaryOfShoppingGuide',
}
export const EmployeeCompensationCostConfig: ModuleConfig = {
  title: '职工薪酬成本', // 二级分组标题
  key: JNPFormNames.employeeCompensationCost,
  isYearData: true,
  data: [
    {
      key: EmployeeCompensationCostNames.employeeSalary,
      name: '职工薪酬(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: EmployeeCompensationCostNames.monthlySalaryOfShoppingGuide,
      name: '导购月均工资(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
  ],
  columns: YearDataColumns,
};

export enum StoreImageCostNames {
  storeImageCost = 'storeImageCost',
  propsPrice = 'propsPrice',
  propsTotal = 'propsTotal',
  lampPrice = 'lampPrice',
  lampTotal = 'lampTotal',
}
export const StoreImageCostConfig: ModuleConfig = {
  title: '店铺形象成本', // 二级分组标题
  key: JNPFormNames.storeImageCost,
  isYearData: false,
  data: [
    {
      key: 'first',
      dataInRow: [
        {
          key: StoreImageCostNames.storeImageCost,
          name: '店铺形象费用(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'second',
      dataInRow: [
        {
          key: StoreImageCostNames.propsPrice,
          name: '道具单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: true,
        },
        {
          key: StoreImageCostNames.propsTotal,
          name: '道具总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'third',
      dataInRow: [
        {
          key: StoreImageCostNames.lampPrice,
          name: '灯具单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: true,
        },
        {
          key: StoreImageCostNames.lampTotal,
          name: '灯具总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    }
  ],
  columns: SpecialDataColumns,
};

export enum StoreEngineeringCostNames {
  storeEngineeringCost = 'storeEngineeringCost',
  facadePrice = 'facadePrice',
  facadeTotal = 'facadeTotal',
  decorationPrice = 'decorationPrice',
  decorationTotal = 'decorationTotal',
  firePrice = 'firePrice',
  fireTotal = 'fireTotal',
  airPrice = 'airPrice',
  airTotal = 'airTotal',
  networkAudioPrice = 'networkAudioPrice',
  networkAudioTotal = 'networkAudioTotal',
}
export const storeEngineeringCostConfig: ModuleConfig =
{
  title: '店铺工程成本', // 二级分组标题
  key: JNPFormNames.storeEngineeringCost,
  isYearData: false,
  data: [
    {
      key: 'first',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.storeEngineeringCost,
          name: '店铺工程费用(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'second',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.facadePrice,
          name: '外立面工程单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: false,
        },
        {
          key: StoreEngineeringCostNames.facadeTotal,
          name: '外立面工程总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'third',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.decorationPrice,
          name: '装修工程单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: true,
        },
        {
          key: StoreEngineeringCostNames.decorationTotal,
          name: '装修工程总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'fourth',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.firePrice,
          name: '消防工程单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: false,
        },
        {
          key: StoreEngineeringCostNames.fireTotal,
          name: '消防工程总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'fifth',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.airPrice,
          name: '空调工程单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: false,
        },
        {
          key: StoreEngineeringCostNames.airTotal,
          name: '空调工程总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
    {
      key: 'sixth',
      dataInRow: [
        {
          key: StoreEngineeringCostNames.networkAudioPrice,
          name: '网络及音响工程单价(元/㎡)',
          value: '',
          unit: '元/㎡',
          unitDetail: '',
          required: false,
        },
        {
          key: StoreEngineeringCostNames.networkAudioTotal,
          name: '网络及音响工程总价(元)',
          value: '',
          unit: '元',
          unitDetail: '',
          disabled: true,
          required: false,
        },
      ]
    },
  ],
  columns: SpecialDataColumns,
};

export enum LeaseCostNames {
  leaseCost = 'leaseCost',
  rent = 'rent',
  propertyManagementFee = 'propertyManagementFee',
  discountRate = 'discountRate',
}
export const LeaseCostConfig: ModuleConfig = {
  title: '租赁费用成本', // 二级分组标题
  key: JNPFormNames.leaseCost,
  isYearData: true,
  data: [
    {
      key: LeaseCostNames.leaseCost,
      name: '租赁成本(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: LeaseCostNames.rent,
      name: '租金(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: false,
    },
    {
      key: LeaseCostNames.propertyManagementFee,
      name: '物业管理费(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: false,
    },
    {
      key: LeaseCostNames.discountRate,
      name: '商场联营扣点',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      required: false,
    },
  ],
  columns: YearDataColumns,
};

export enum OtherCostNames {
  otherCost = 'otherCost',
  waterElectricityFee = 'waterElectricityFee',
  officeExpenses = 'officeExpenses',
  internetFee = 'internetFee',
  publicityExpenses = 'publicityExpenses',
  workClothesExpenses = 'workClothesExpenses',
  incidentalExpenses = 'incidentalExpenses',
}
export const OtherCostConfig: ModuleConfig = {
  title: '其他类别费用成本', // 二级分组标题
  key: JNPFormNames.otherCost, // 模块key
  isYearData: true,
  data: [
    {
      key: OtherCostNames.otherCost,
      name: '其他成本(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: OtherCostNames.waterElectricityFee,
      name: '水电费（年）',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: OtherCostNames.officeExpenses,
      name: '日常办公费用(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: OtherCostNames.internetFee,
      name: '宽带费(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: OtherCostNames.publicityExpenses,
      name: '日常宣传品费用(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: OtherCostNames.workClothesExpenses,
      name: '工服费用(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
    {
      key: OtherCostNames.incidentalExpenses,
      name: '运费及杂费(元)',
      firstYear: '',
      secondYear: '',
      unit: '元',
      unitDetail: '',
      required: true,
    },
  ],
  columns: YearDataColumns,
};

// 组件内配置的核心信息字段
export enum CoreInfoRelateNames {
  collaborationMode = 'collaborationMode', // 合作模式
  basicUsableArea = 'basicUsableArea', // 提报合同面积
  employeeStaffing = 'employeeStaffing', // 员工编制数量（含店长）
};

// 合作模式选项
enum CollaborationMode {
  rent = '租赁',
  discount = '扣点',
  highValue = '取高',
};

export const isCollaborationModeRent = (name: string) => {
  return name === CollaborationMode.rent;
};

export const isCollaborationModeDiscount = (name: string) => {
  return name === CollaborationMode.discount;
};

export const isCollaborationModeHighValue = (name: string) => {
  return name === CollaborationMode.highValue;
};

export enum CoreInfoNames {
  totalProfit = 'totalProfit',
  profitMargin = 'profitMargin',
  grossMargin = 'grossMargin',
  priceToRent = 'priceToRent',
  rentalRatio = 'rentalRatio',
  salaryRatio = 'salaryRatio',
  hrEfficiency = 'hrEfficiency',
  yearSalesEffect = 'yearSalesEffect',
  monthSalesEffect = 'monthSalesEffect',
}

export const CoreInfoConfig: ModuleConfig = {
  title: '盈亏测算', // 二级分组标题
  key: JNPFormNames.coreInfoModule, // 模块key
  isYearData: true,
  data: [
    {
      key: CoreInfoNames.totalProfit,
      name: '利润总额(万)',
      firstYear: '',
      secondYear: '',
      unit: '',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.profitMargin,
      name: '利润率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.grossMargin,
      name: '毛利率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.priceToRent,
      name: '租售比',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.rentalRatio,
      name: '租赁费用率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.salaryRatio,
      name: '薪酬费用率',
      firstYear: '',
      secondYear: '',
      unit: '%',
      unitDetail: '%',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.hrEfficiency,
      name: '人效(万/人)',
      firstYear: '',
      secondYear: '',
      unit: '',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.yearSalesEffect,
      name: '年坪效(规划面积m²)',
      firstYear: '',
      secondYear: '',
      unit: '',
      unitDetail: '',
      disabled: true,
      required: false,
    },
    {
      key: CoreInfoNames.monthSalesEffect,
      name: '月坪效(规划面积m²)',
      firstYear: '',
      secondYear: '',
      unit: '',
      unitDetail: '',
      disabled: true,
      required: false,
    },
  ],
  columns: YearDataColumns,
};
